module.exports = __webpack_public_path__ + "media/images/client/RentSearchApplication/success-574c7311a0983507b968b81c7e737f68.svg";